"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_gateway_client_request_1 = require("./../../../services/gateway-control/base-gateway-client-request");
var gateway_request_type_1 = require("./../../../services/gateway-control/gateway-request-type");
/**
 * Data type for a GATEWAY_CLIENT_REQUEST invoke operation request.
 */
var GatewayClientInvokeOperationRequest = /** @class */ (function (_super) {
    __extends(GatewayClientInvokeOperationRequest, _super);
    /**
     * Create a new GatewayClientInvokeOperationRequest instance
     *
     * @param sessionId  the gateway client session id
     * @param operationName  the name of the operation to invoke
     * @param input  optional input data in the form of a JSON string
     */
    function GatewayClientInvokeOperationRequest(sessionId, operationName, input) {
        var _this = _super.call(this, sessionId) || this;
        _this.type = gateway_request_type_1.GatewayRequestType.INVOKE_OPERATION;
        _this.operationName = operationName;
        _this.input = input;
        return _this;
    }
    return GatewayClientInvokeOperationRequest;
}(base_gateway_client_request_1.BaseGatewayClientRequest));
exports.GatewayClientInvokeOperationRequest = GatewayClientInvokeOperationRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/operations/gateway-client-invoke-operation-request.js
// module id = 1249
// module chunks = 1